import axios from 'axios';
import config from '../../config';

export const RECORD_SURVEY_ENTRY_REQUEST = 'RECORD_SURVEY_ENTRY_REQUEST';
export const RECORD_SURVEY_ENTRY_SUCCESS = 'RECORD_SURVEY_ENTRY_SUCCESS';
export const RECORD_SURVEY_ENTRY_FAILURE = 'RECORD_SURVEY_ENTRY_FAILURE';
export const RECORD_SURVEY_ENTRY_RESET = 'RECORD_SURVEY_ENTRY_RESET';

export const GET_RESPONDENT_REQUEST = 'GET_RESPONDENT_REQUEST';
export const GET_RESPONDENT_SUCCESS = 'GET_RESPONDENT_SUCCESS';
export const GET_RESPONDENT_FAILURE = 'GET_RESPONDENT_FAILURE';
export const GET_RESPONDENT_RESET = 'GET_RESPONDENT_RESET';

export const recordSurveyEntryApi = (transaction_id, campaign_id, psid) => async (dispatch) => {
  dispatch({ type: RECORD_SURVEY_ENTRY_REQUEST });
  try {
    const params = new URLSearchParams();
    if (transaction_id) params.append('transaction_id', transaction_id);
    if (campaign_id) params.append('campaign_id', campaign_id);
    if (psid) params.append('psid', psid);

    const response = await axios.get(
      `${config.api.base_url}/survey-respondents/entry?${params.toString()}`
    );

    dispatch({
      type: RECORD_SURVEY_ENTRY_SUCCESS,
      response: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to record survey entry';
    dispatch({
      type: RECORD_SURVEY_ENTRY_FAILURE,
      error: errorMessage,
    });
    throw error;
  }
};

export const recordSurveyEntryReset = () => ({
  type: RECORD_SURVEY_ENTRY_RESET,
});

export const getRespondentByTransactionIdApi = (transaction_id, sid = null) => async (dispatch) => {
  dispatch({ type: GET_RESPONDENT_REQUEST });
  try {
    // sid = per-attempt send id from the invite link (&sid=) - lets the backend attribute this
    // landing to the exact email attempt (first send vs resend). Optional and backward compatible.
    const response = await axios.get(
      `${config.api.base_url}/survey-respondents/${transaction_id}${sid ? `?sid=${encodeURIComponent(sid)}` : ''}`
    );

    dispatch({
      type: GET_RESPONDENT_SUCCESS,
      response: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to get respondent';
    dispatch({
      type: GET_RESPONDENT_FAILURE,
      error: errorMessage,
    });
    throw error;
  }
};

export const getRespondentReset = () => ({
  type: GET_RESPONDENT_RESET,
});
